module.exports = __webpack_public_path__ + "static/img/review-propile-test.9845c6cf.svg";